import React from 'react';
import { InputText } from 'components/inputText/inputText';
import { formatText } from 'core/i18n';
import validator from 'validator';

const isRequired = value => value && value.length;
const isValidMonth = value => validator.matches(value, /^[0-9]|^1[0-2]$/) && value <= 12;
export const BirthMonth = ({
    userProfile,
    userProfileForm,
    formActions,
    handleCursor,
    validateGroups,
    onFocus,
    onBlur,
}) => {
    return (
        <div className="col-xs-3 input-month-day middle-col">
            <InputText
                profileModel="userProfile.birthMonth"
                type="text"
                inputMode="numeric"
                pattern="[0-9]*"
                name="birthMonth"
                placeholder={formatText('field-birthMonth')}
                maxLength={2}
                disabled={userProfile?.birthDayDisabled}
                onlyDigits
                onChange={event => handleCursor(event)}
                validations={{
                    required: isRequired,
                    valid: isValidMonth,
                }}
                isValidated={() => validateGroups('birthMonth', true)}
                isNotValidated={() => validateGroups('birthMonth', false)}
                messagesError={{ required: '' }}
                userProfileForm={userProfileForm}
                userProfile={userProfile}
                formActions={formActions}
                onFocus={onFocus}
                onBlur={onBlur}
            />
        </div>
    );
};
